function setAnimProgressBar(state, value) {
  state.progressBar = value;
}

function setAnimStatus(state, value) {
  state.status = value;
}

function setAnimCurrentStep(state, value) {
  state.currentStep = value;
}

export default {
  setAnimProgressBar,
  setAnimStatus,
  setAnimCurrentStep
};
